import type { Language } from "@porsche-customer/slfinrtl-context-types"
import screenshotEn from "./screenshot-notification-center-en.jpg"
import screenshotHr from "./screenshot-notification-center-hr.jpg"
import screenshotSk from "./screenshot-notification-center-sk.jpg"

export const supportedLanguages = ["en", "hr", "sk"] as const satisfies readonly Language[]
export type SupportedLanguage = (typeof supportedLanguages)[number]

export const whatsNewMessages: Record<
	SupportedLanguage,
	{
		body: string
		buttonLabel: string
		heading: string
		subHeading: string
	}
> = {
	en: {
		body: `The new Dealer Notification Center brings together key information and required actions, so you can quickly see what needs your attention.

**What you can expect:**
- Notifications on required actions, such as missing images or first registration dates
- Alerts on relevant changes, such as delivery delays or configuration updates
- One central place for your relevant notifications

This feature is currently being rolled out as a pilot in your market. We welcome your feedback as we continue to refine it.

![Screenshot](${screenshotEn})

You can share your feedback anytime via the Feedback button.`,
		buttonLabel: "News",
		heading: "🔔 What's New: Dealer Notification Center",
		subHeading: "Relevant updates and required actions – all in one place",
	},

	hr: {
		body: `Novi Centar obavijesti za trgovce objedinjuje ključne informacije i potrebne radnje kako biste brzo vidjeli što zahtijeva vašu pažnju.

**Što možete očekivati:**
- Obavijesti o potrebnim radnjama, kao što su nedostajuće slike ili datumi prve registracije
- Upozorenja o relevantnim promjenama, kao što su kašnjenja u isporuci ili ažuriranja konfiguracije
- Jedno središnje mjesto za vaše relevantne obavijesti

Ova značajka trenutačno se uvodi kao pilot-projekt na vašem tržištu. Vaše povratne informacije dobrodošle su nam dok je nastavljamo usavršavati.

![Screenshot](${screenshotHr})

Povratne informacije možete podijeliti u bilo kojem trenutku putem gumba Povratne informacije.`,
		buttonLabel: "Novosti",
		heading: "🔔 Novosti: Centar obavijesti za trgovce",
		subHeading: "Relevantne novosti i potrebne radnje – sve na jednom mjestu",
	},

	sk: {
		body: `Nové Centrum oznámení pre predajcov spája kľúčové informácie a potrebné kroky, aby ste rýchlo videli, čo si vyžaduje vašu pozornosť.

**Čo môžete očakávať:**
- Upozornenia na potrebné kroky, napríklad chýbajúce obrázky alebo dátumy prvej registrácie
- Upozornenia na relevantné zmeny, napríklad meškanie dodávok alebo aktualizácie konfigurácie
- Jedno centrálne miesto pre vaše relevantné oznámenia

Táto funkcia sa momentálne zavádza ako pilotný projekt na vašom trhu. Uvítame vašu spätnú väzbu, keďže ju budeme naďalej vylepšovať.

![Screenshot](${screenshotSk})

Svoju spätnú väzbu môžete kedykoľvek zdieľať prostredníctvom tlačidla Spätná väzba.`,
		buttonLabel: "Novinky",
		heading: "🔔 Novinky: Centrum oznámení pre predajcov",
		subHeading: "Dôležité aktualizácie a potrebné kroky – všetko na jednom mieste",
	},
}
